import { createSelector } from '@reduxjs/toolkit';

import { entityDrawerSelector } from 'src/selectors/entityDrawer';
import { projectSensitivePropertyGroupsByNameSelector } from 'src/selectors/projectSensitivePropertyGroupsByName';

export const entityDrawerSensitivePropertyGroupDataSelector = (
  projectId: string
) =>
  createSelector(
    entityDrawerSelector,
    projectSensitivePropertyGroupsByNameSelector(projectId),
    (drawer, sensitivePropertyGroups) =>
      drawer.entityValue
        ? {
            name: drawer.entityValue,
            attributes: sensitivePropertyGroups[drawer.entityValue] || [],
          }
        : null
  );
